<div class="container-fluid" >
  <div class="row">
    <div class="col-md-7 col-sm-12">
      <app-card [title]="'admin.order.detail'|translate">
        <!--   reference-->
        <div class="form-group ">
          <div class="container">
            <div class="card-align">
              <div class="row">
                <label class="col-sm-4 col-form-label no-padding left-pos">
                  <span class="labelWithToolTip">{{'doctrine.order.reference'|translate}}<span
                    class="star">*</span></span>
                  <!--tooltip-item-->
                  <span class="tooltip-item">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                          {{'admin.dealer.order.reference_description'|translate}}
                          </div>
                        </ng-container>
                    </span>
                       </span>
                </label>
                <div class="col-sm-6">
                  <p class="field-place">{{ quote.reference }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--deliveryWeek-->
        <div class="form-group" *ngIf="quote.deliveryWeek">
          <div class="container">
            <div class="card-align">
              <div class="row">
                <label class="col-sm-4 col-form-label no-padding  left-pos">
                  <span class="labelWithToolTip">  {{'admin.dealer.order.delivery_week'|translate}}</span>
                  <!--tooltip-item-->
                  <span class="tooltip-item">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                          {{'admin.dealer.order.delivery_week_description'|translate}}
                          </div>
                        </ng-container>
                    </span>
                       </span>

                </label>
                <div class="col-sm-6">
                  <p class="field-place" *ngIf="order.deliveryWeek">{{order.deliveryWeek|DateFormat}}</p>
                  <p class="field-place" *ngIf="!order.deliveryWeek">{{'global.as_soon_as_possible'|translate}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--allowPartial-->
        <div class="form-group " *ngIf="quote.allowPartial!==null">
          <div class="container">
            <div class="card-align">
              <div class="row">
                <label class="col-sm-4 col-form-label no-padding left-pos">
                  <span class="labelWithToolTip">{{'doctrine.user.allow_partial_order_description'|translate}}
                    </span>
                  <!--tooltip-item-->
                  <span class="tooltip-item">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                          {{'admin.dealer.order.reference_description'|translate}}
                          </div>
                        </ng-container>
                    </span>
                       </span>
                </label>
                <div class="col-sm-6">
                  <p class="field-place">{{ order?.allowPartial}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </app-card>
      <!--
      ====================================
      # Order Items (Articles) - [start]
      ====================================
      -->
      <app-card *ngFor="let orderItem of quote.orderItems;let i=index;"
                [title]="'admin.order.article'|translate:{'number': i+1}">
        <!-- Details for collection
         ------------------------->
        <div class="form-group ">
          <div class="container">
            <div class="card-align">
              <div class="row">
                <label class="col-sm-4 col-form-label no-padding left-pos">
                  <span class="labelWithToolTip"> {{'doctrine.attributes.collection'|translate}}
                    <span class="star">*</span></span>
                  <!--tooltip-item-->
                  <span class="tooltip-item">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                         {{'admin.dealer.order.collection_description'|translate}}
                          </div>
                        </ng-container>
                    </span>
                       </span>

                </label>
                <div class="col-sm-6 ">
                  <p class="field-place">
                    {{ orderItem.collection.name}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Details for model
         --------------------->
        <div class="form-group ">
          <div class="container">
            <div class="card-align">
              <div class="row">
                <label class="col-sm-4 col-form-label no-padding left-pos">
                  <span class="labelWithToolTip">  {{'doctrine.attributes.model'|translate}} <span class="star">*</span></span>
                  <!--tooltip-item-->
                  <span class="tooltip-item">
                         <span class="tooltipBox">
                           <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                         </span>
                        <span class="desc-place">
                        <ng-container>
                          <div>
                          {{'admin.dealer.order.model_description'|translate}}
                          </div>
                        </ng-container>
                    </span>
                       </span>
                </label>
                <div class="col-sm-6">
                  <p class="field-place">
                    <span> {{ orderItem.model.name}}</span>
                    <span *ngIf="orderItem.style!==null">,{{ orderItem.style.name}}</span>

                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
        ======================================================
        # Products (Products/Elements of an Article) - [start]
        ======================================================
        -->
        <ng-container *ngFor="let productItem of orderItem.orderItemProducts;let j=index;">
          <div class="mb-2 container">
            <div class="row">
              <div class="col-lg-6">
                <strong>{{'admin.order.element'|translate}} {{orderItemCount(j)}}</strong>
              </div>
            </div>
          </div>
          <div class="container">
            <!--insert product col-->
            <div class="mb-4 mt-4 bg-light text-dark">
              <div class="card-body fabrics">
                <div class="container">
                  <!--form with  with img  -->
                  <div class="row">
                    <!--form-box-->
                    <div class=" col-md-10 col-sm-8 no-padding-left">
                      <div class="form-group ">
                        <div class="container">
                          <div class="row">
                            <label class="col-sm-5 col-form-label no-padding-left left-pos">
                                 <span class="labelWithToolTip">
                                      {{'doctrine.attributes.product'|translate}} <span class="star">*</span>
                                 </span>
                              <!--tooltip-item-->
                              <span class="tooltip-item" *ngIf=" productItem.product.description">
                                 <span class="tooltipBox">
                                   <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                 </span>
                                <span class="desc-place">
                                <ng-container>
                                  <div>
                                   {{productItem.product.description}}
                                  </div>
                                </ng-container>
                            </span>
                               </span>

                            </label>
                            <div class="col-sm-7  no-padding ">
                              <div class="row">
                                <div class="col-sm-1">
                                  <p class="field-place">
                                    {{ productItem.amount}}
                                  </p>
                                </div>
                                <div class="col-sm-11">
                                  <p class="field-place">
                                    <span>
                                        {{ productItem.product.name }}
                                    </span>
                                  </p>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Fabric -------------------------------------------------------->
                      <div class="form-group" *ngIf="productItem.orderItemProductFabricCollections.length !== 0 && checkHasFabric(productItem.orderItemProductFabricCollections[0])">
                        <div class="container">
                          <div class="row">
                            <label class="col-form-label col-sm-5 no-padding-left left-pos">
                                 <span class="labelWithToolTip">{{'doctrine.attributes.fabric'|translate}}
                                   <span class="star"> *</span>
                                 </span>
                              <!--tooltip-item-->
                              <span class="tooltip-item">
                                 <span class="tooltipBox">
                                   <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                 </span>
                                <span class="desc-place">
                                <ng-container>
                                  <div>
                                      {{'admin.dealer.order.fabric_description'|translate}}
                                  </div>
                                </ng-container>
                            </span>
                               </span>

                            </label>
                            <!-- Fabric collection, Fabric, Fabric color (with image)
                             -------------------------------------------------------->
                            <div class="col-sm-7 no-padding">
                              <div class="row" *ngFor="let fabricItem of productItem.orderItemProductFabricCollections">
                                <div class="col-sm-12" *ngIf="fabricItem.fabricCollection">
                                  <p class="field-place">
                                    {{ (fabricItem.fabricCollection.name) + ' , ' + (fabricItem.fabric.name) + ' , ' + (fabricItem.fabricColor.name) }}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Product packages ----------------------------------------------->
                      <div *ngIf="productItem.orderItemProductPackages.length !== 0">
                        <div class="container">
                          <div class="row" *ngFor="let packageProduct of productItem.orderItemProductPackages">
                              <label class="col-form-label col-sm-5 no-padding-left left-pos form-group" *ngIf="packageProduct.orderItemProductPackageProducts[0]">
                                   <span class="labelWithToolTip">
                                     {{packageProduct.package.name}}
                                   </span>
                                <!--tooltip-item-->
                                <span class="tooltip-item" *ngIf="packageProduct.orderItemProductPackageProducts[0]">
                                   <span class="tooltipBox">
                                     <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                   </span>
                                    <span class="desc-place">
                                      <ng-container>
                                        <div *ngIf="packageProduct.orderItemProductPackageProducts[0] && packageProduct.orderItemProductPackageProducts[0].product">
                                            {{packageProduct.orderItemProductPackageProducts[0].product.description}}
                                        </div>
                                      </ng-container>
                                    </span>
                                 </span>
                              </label>
                              <div class="col-sm-7 no-padding" *ngIf="packageProduct.orderItemProductPackageProducts[0] && packageProduct.orderItemProductPackageProducts[0].product">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <p class="field-place">
                                      {{packageProduct.orderItemProductPackageProducts[0].product.name}}
                                    </p>
                                  </div>
                                </div>
                              </div>
                          </div>
                        </div>
                      </div>
                      <!-- End of product packages ----------------------------------------------->

                    </div>
                    <!-- Product image ---------------->
                    <div *ngIf="productItem.product" class="col-md-2 col-sm-4 text-center">
                          <span *ngIf="productItem.product.image">
                            <ng-container *ngIf="productItem.product.image.fileManagers;else doesntHaveFileManagers">
                                 <img alt="image" class="img-fluid" width="150" height="50"
                                      src="{{ baseURL + '/' + productItem.product.image.fileManagers.small.fullPath }}"/>
                            </ng-container>
                            <ng-template #doesntHaveFileManagers>
                                    <img alt="image" class="img-fluid" width="150" height="50"
                                         src="{{ baseURL + '/' + productItem.product.image.fullPath }}"/>
                            </ng-template>
                          </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </ng-container>
        <ng-container *ngIf="options[i] && options[i].length>0">
          <b>{{ 'doctrine.order.options'|translate }} {{i + 1}}</b>
          <div class="m-3 bg-light text-dark">
            <div class="card-body option">
              <div class="row">
                <div class="col-md-12 no-padding">
                  <div class="form-group ">
                    <div class="container">
                      <div class="card-align">
                        <ng-container *ngFor="let item of options[i];let index=index;">
                          <!-- first level-->
                          <div class="row">
                            <label class="col-sm-4 col-form-label no-padding left-pos">
                              <span class="labelWithToolTip">{{item.parent}}</span>
                              <!--tooltip-item-->
                              <span class="tooltip-item" *ngIf="item.hasOwnProperty('parent_description')">
                                                <span class="tooltipBox">
                                                  <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                                 </span>
                                                <span class="desc-place">
                                                <ng-container>
                                                  <div>
                                                {{item.parent_description}}
                                                  </div>
                                                </ng-container>
                                            </span>
                                              </span>
                            </label>
                            <div class="col-sm-6">
                              <p class="field-place">
                                              <span>
                                                 {{item.current}}
                                              </span>
                                <!--Option Type-->
                                <ng-container *ngIf="item.type=='Option' && item.hasOwnProperty('children')">
                                  <ng-container *ngFor="let childrenFirstLevel Of item.children">
                                    <span>,{{childrenFirstLevel.current}}</span>
                                  </ng-container>
                                </ng-container>
                              </p>
                            </div>
                          </div>
                          <!-- other level fabric-->
                          <ng-container *ngIf="item.type=='Fabric'">
                            <div class="row">
                              <label class="col-sm-4 col-form-label no-padding left-pos">
                                                <span class="labelWithToolTip"
                                                      [ngStyle]="{'text-indent.px': '15' }">{{'doctrine.attributes.fabric'|translate}}</span>

                              </label>
                              <div class="col-sm-6">
                                <p class="field-place">
                                  <span>{{item.fabricCollection}}</span>
                                  <span>,{{item.fabric}}</span>
                                  <span>,{{item.fabricColor}}</span>

                                </p>
                              </div>
                            </div>
                          </ng-container>
                          <!-- other level option-->
                          <ng-container *ngIf="item.type=='Option'&& item.hasOwnProperty('children') ">
                            <ng-container *ngFor="let children Of item.children">
                              <ng-container *ngIf="children.type=='Fabric'">
                                <div class="row">
                                  <label class="col-sm-4 col-form-label no-padding left-pos">
                                                    <span class="labelWithToolTip"
                                                          [ngStyle]="{'text-indent.px': '15' }">{{'doctrine.attributes.fabric'|translate}}</span>
                                  </label>
                                  <div class="col-sm-6">
                                    <p class="field-place">
                                      <span>{{children.fabricCollection}}</span>
                                      <span>,{{children.fabric}}</span>
                                      <span>,{{children.fabricColor}}</span>

                                    </p>
                                  </div>
                                </div>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                          <!--other level select-->
                          <ng-container *ngIf="item.type=='Select' && item.hasOwnProperty('children')">
                            <ng-container *ngFor="let selectChild of item.children;let s=index">
                              <div class="row">
                                <label class="col-sm-4 col-form-label no-padding left-pos">
                                                  <span class="labelWithToolTip"
                                                        [ngStyle]="{'text-indent.px': '15' }">{{selectChild.parent}}</span>
                                </label>
                                <div class="col-sm-6">
                                  <p class="field-place">
                                    <span>{{selectChild.current}}</span>
                                    <!-- select Option-->
                                    <ng-container
                                      *ngIf="selectChild.type=='Option' && selectChild.hasOwnProperty('children')">
                                      <ng-container *ngFor="let selectOptionChild Of selectChild.children">
                                        <span>,{{selectOptionChild.current}}</span>
                                      </ng-container>
                                    </ng-container>
                                  </p>
                                </div>
                              </div>
                              <!-- select fabric-->
                              <ng-container *ngIf="selectChild.type=='Fabric'">
                                <div class="row">
                                  <label class="col-sm-4 col-form-label no-padding left-pos">
                                                    <span class="labelWithToolTip"
                                                          [ngStyle]="{'text-indent.px': '30' }">{{'doctrine.attributes.fabric'|translate}}</span>

                                  </label>
                                  <div class="col-sm-6">
                                    <p class="field-place">

                                      <span>{{selectChild.fabricCollection}}</span>
                                      <span>,{{selectChild.fabric}}</span>
                                      <span>,{{selectChild.fabricColor}}</span>

                                    </p>
                                  </div>
                                </div>

                              </ng-container>
                              <!-- select select-->
                              <ng-container
                                *ngIf="selectChild.type=='Select' && selectChild.hasOwnProperty('children')">
                                <ng-container *ngFor="let selectSelectChild Of selectChild.children">
                                  <div class="row">
                                    <label class="col-sm-4 col-form-label no-padding left-pos">
                                                    <span class="labelWithToolTip"
                                                          [ngStyle]="{'text-indent.px': '30' }">{{'doctrine.attributes.fabric'|translate}}</span>
                                      <!--tooltip-item-->
                                      <span class="tooltip-item">
                                                <span class="tooltipBox">
                                                  <i class="fa fa-info-circle fa-2x " aria-hidden="true"></i>
                                                 </span>
                                                <span class="desc-place">
                                                <ng-container>
                                                  <div>
                                                  Seating comfort Information
                                                  </div>
                                                </ng-container>
                                            </span>
                                              </span>
                                    </label>
                                    <div class="col-sm-6">
                                      <p class="field-place">
                                        <span>{{selectSelectChild.current}}</span>
                                      </p>
                                    </div>
                                  </div>
                                </ng-container>
                              </ng-container>
                              <!--end-->
                            </ng-container>
                            <!--select have child end-->
                          </ng-container>
                          <!--allItemFor-->
                        </ng-container>
                      </div>
                      
                    </div>
                  </div>
                </div>

              </div>


            </div>
          </div>

        </ng-container>

        <!--end-->
      </app-card>
    </div>


    <!--
    ====================================
    # Summary box (right part)
    ====================================
    -->
    <div class="col-md-5 col-sm-12">
      <app-card id="summary_box" [title]="'admin.order.summary.title'|translate">
        <div class="col-12">
          <div class="form-radio d-flex">
            <div class="radio radio-inline">
              <label>
                <input type="radio" name="radio" [value]="true" [(ngModel)]="priceItem" (change)="getDealerPrice(true)">
                <i class="helper"></i>{{'doctrine.product.customer_price'|translate}}
              </label>
            </div>
            <div class="radio radio-inline">
              <label>
                <input type="radio" name="radio" [value]="false" [(ngModel)]="priceItem"
                       (change)="getDealerPrice(false)">
                <i class="helper"></i>{{'doctrine.product.dealer_price'|translate}}
              </label>
            </div>
          </div>
        </div>
        <p>
          {{'admin.order.summary.description'|translate}}
        </p>
        <div class="table-responsive">
          <table class="table m-0">
            <thead>
            <tr>
              <th>{{'doctrine.attributes.articels'|translate}}</th>
              <th>{{'doctrine.product.amount'|translate}} </th>
              <th> {{'admin.order.price'|translate}} </th>
              <th>{{'admin.order.total'|translate}}</th>
            </tr>
            </thead>
            <tbody>

            <ng-container *ngFor="let orderItem of quote.orderItems; let z = index;">
              <tr class="divider" *ngIf="orderItem.orderItemProducts">
                <td colspan="4" class="line-article"></td>
              </tr>

              <tr *ngFor="let orderItemProduct of orderItem.orderItemProducts; let m = index;">
                <ng-container class="pb-0 tr-view" *ngIf="orderItemProduct.product">
                  <!-- Products, Fabrics, Packages, Properties
                   ------------------------------------------>
                  <td class="p-1 " class="line-space">
                    <p class="mb-1" *ngIf="orderItemProduct.product">
                        {{orderItem.model ? orderItem.model.name : ''}}
                        {{orderItem.style ? orderItem.style.name : ''}}
                        {{orderItemProduct.product.name}}
                    </p>
                    <p class="ms-5 mb-1" *ngIf="orderItemProduct.orderItemProductFabricCollections">
                      <ng-container *ngFor="let fabric of orderItemProduct.orderItemProductFabricCollections">
                        {{ 'doctrine.fabric.fabric'|translate}}:
                        {{(fabric.fabricCollection) ? fabric.fabricCollection.name + ',' : ''}}
                        <span *ngIf="fabric.fabricCollection.isCustom">
                          {{fabric.fabricName+ ','}}
                          {{fabric.fabricColorName }}
                        </span>
                        <span *ngIf="!fabric.fabricCollection.isCustom">
                          {{(fabric.fabric) ? fabric.fabric.name + ',' : ''}}
                          {{(fabric.fabricColor) ? fabric.fabricColor.name : '' }}
                        </span>
                      </ng-container>
                    </p>
                    <ng-container
                      *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                      <p class="ms-5 mb-0"
                         *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0] && orderItemProductPackage.orderItemProductPackageProducts[0].productObj">
                        {{orderItemProductPackage.packageObj.name}}
                        <ng-container
                          *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                                      <span>
                                        {{orderItemProductPackageProduct.productObj.name}}
                                      </span>
                        </ng-container>
                      </p>
                    </ng-container>
                  </td>

                  <td class="p-1" *ngIf="orderItemProduct.amount">
                    {{ orderItemProduct.amount }}
                  </td>

                  <td class="p-1">
                      <span>
                        {{ (orderItemProduct.cost.customerPrice ? orderItemProduct.cost.customerPrice : orderItemProduct.cost.dealerPrice) | CustomCurrency }}
                      </span>
                      <p class="ms-5 mb-0" *ngIf="orderItemProduct.orderItemProductFabricCollections">
                        <ng-container *ngFor="let fabric of orderItemProduct.orderItemProductFabricCollections">
                          {{ (fabric.fabricCollection != null && fabric.fabricCollection.customerPrice ? fabric.fabricCollection.customerPrice : ((fabric.fabricCollection != null && fabric.fabricCollection.dealerPrice)?fabric.fabricCollection.dealerPrice:0)) | CustomCurrency }}
                        </ng-container>
                      </p>
                    <ng-container
                      *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;let z=index">

                      <ng-container
                        *ngFor="let orderItemProductPakcageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                        <div *ngIf="orderItemProductPackage.orderItemProductPackageProducts[0].product">

                          {{ (orderItemProductPakcageProduct.cost.customerPrice ? orderItemProductPakcageProduct.cost.customerPrice : orderItemProductPakcageProduct.cost.dealerPrice) | CustomCurrency }}
                        </div>
                      </ng-container>
                    </ng-container>


                  </td>
                  <!-- Prices
                   ------------------------>
                  <td class="p-1 ">
                    <span>
                      {{(orderItemProduct.totalCost.totalCustomerCost? orderItemProduct.totalCost.totalCustomerCost : orderItemProduct.totalCost.totalDealerCost) | CustomCurrency }}
                    </span>
                    <p class="mb-0" *ngIf="orderItemProduct.orderItemProductFabricCollections">
                      <ng-container
                        *ngFor="let fabricCollection of orderItemProduct.orderItemProductFabricCollections">
                        {{(fabricCollection.totalCost.totalCustomerPrice ? fabricCollection.totalCost.totalCustomerPrice : fabricCollection.totalCost.totalDealerPrice) | CustomCurrency }}
                      </ng-container>
                    </p>
                    <ng-container
                      *ngFor="let orderItemProductPackage of orderItemProduct.orderItemProductPackages;">
                      <ng-container
                        *ngFor="let orderItemProductPackageProduct of orderItemProductPackage.orderItemProductPackageProducts">
                      </ng-container>
                    </ng-container>
                  </td>
                </ng-container>
              </tr>
            </ng-container>
            <tr class="total-price">
              <td class="p-1" colspan="3">
                <strong>{{'admin.order.summary.total.description'|translate}}</strong> {{'admin.order.summary.total.description.incvat'|translate}}
              </td>
              <td class="p-1">
                <strong>
                  {{ (quote.totalCost.totalCustomerCost ? quote.totalCost.totalCustomerCost : quote.totalCost.totalDealerCost) | CustomCurrency}}
                </strong>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="pt-4 d-flex justify-content-between">
          <button (click)="getQuotePdf()" class="btn ripple light btn-grey" type="button">
                    <span *ngIf="this.customerPrice">
                      {{'global.quote_customer_pdf'|translate}}
                    </span>
                    <span *ngIf="!this.customerPrice">
                      {{'global.quote_dealer_pdf'|translate}}
                    </span>
                  </button>
          <button type="button" class="btn btn-primary ripple light ms-1"
                  (click)="EditOrder()">{{'global.edit_quote'|translate}}
          </button>
        </div>


      </app-card>

    </div>
  </div>
</div>
<a #downloadLink href="" download style="display: none"></a>


<!--
====================================
# Modal password
====================================
-->
<app-modal-basic #passwordModal [dialogClass]="'modal-md'" [hideOnClickOutside]="false">
  <div class="app-modal-header">
    <h4 class="modal-title">{{'admin.send_dealer_password'|translate}}</h4>
    <button type="button" class="close basic-close" (click)="checkPasswordError()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form #passwordModalForm="ngForm">
      <div class="form-group form-primary">
        <label class="float-label">{{'admin.dealer_password'|translate}}</label>
        <input type="password" name="password" #password="ngModel" class="form-control" [(ngModel)]="dealerPassword"
               required minlength="6">
        <span class="form-bar"></span>
        <div class="messages text-danger"
             *ngIf="password.invalid && password.dirty && password.errors?.required">{{'errors.required'|translate}}{{password.invalid && password.dirty}}</div>
        <div class="messages text-danger"
             *ngIf="password?.errors?.minlength">{{'auth.signin.password.minlength'|translate}}</div>
      </div>
      <div class="app-modal-footer d-flex justify-content-between w-100">
        <button type="button" class="btn btn-simple btn-md ripple"
                (click)="checkPasswordError()">{{'global.cancel'|translate}}</button>
        <button type="submit" class="btn btn-primary btn-md ripple light"
                (click)="getCustomerPrice()">{{'global.get_customer_price'|translate}}</button>
      </div>
    </form>
  </div>

</app-modal-basic>
